export const revokeInputFarsi = (value, callback) => {
  const reg = /[ا-ی۰-۹]/g;
  if (value.match(reg)) {
    value = value.replace(reg, '');
    callback(value);
  }
};
